import React from 'react';
import '../pages/ViewDataPage/styles.css';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 24 }}>
        <div className="view-data-section" style={{ maxWidth: 1200, margin: '80px auto' }}>
          <div style={{ marginBottom: 16 }}>
            <div className="skeleton-content" style={{ height: 28, width: '40%', marginBottom: 8 }}></div>
            <div className="skeleton-content" style={{ height: 16, width: '60%' }}></div>
          </div>
          <div className="view-data-table-container">
            <table className="view-data-table table-skeleton">
              <thead>
                <tr>
                  {[...Array(5)].map((_, i) => (
                    <th key={i}><div className="skeleton-content" style={{ height: 14, width: '60%' }}></div></th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, r) => (
                  <tr key={r} className="skeleton-row">
                    {[...Array(5)].map((_, c) => (
                      <td key={c} className="skeleton-cell">
                        <div className="skeleton-content" style={{ height: 14, width: `${50 + (c*10)%40}%` }}></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default AdminRoute;


